import Cookies from 'js-cookie';
import JWTDecode from 'jwt-decode';

export const AUTH_KEY = 'PSSID';
export const USER_DATA_KEY = 'polibras:user';

const domain = process.env.REACT_APP_COOKIE_DOMAIN;
const path = '/';

class Auth {

    getToken() {
        const PSSID = Cookies.get(AUTH_KEY);

        if (PSSID) {
            return window.atob(PSSID);
        }

        return null;
    }

    getUserData() {
        const data = Cookies.get(USER_DATA_KEY) || null;

        if (data) {
            return JSON.parse(window.atob(data));
        }

        return {};
    }

    getSessionData() {
        const token = this.getToken();

        if (token) {
            return JWTDecode(token);
        }

        return {};
    }

    isAuthenticated() {
        const token = this.getToken();
        return !!token;
    }

    redirectIfHasNoToken() {
        const isAuthenticated = this.isAuthenticated();

        if (!isAuthenticated) {
            this.redirectToAccounts();
        }

        return !isAuthenticated;
    }

    redirectToAccounts() {
        window.location = process.env.REACT_APP_ACCOUNTS_APP + '?continue='+window.location.href;
    }

    signout() {
        Cookies.remove(AUTH_KEY, {domain, path});
    }
}

export default new Auth();




// WEBPACK FOOTER //
// ./src/psuite-js/helpers/auth.js